import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

function ArticleStructuredData({
  headline, datePublished, dateModified, byline,
}) {
  const author = {
    '@type': 'Person',
    name: byline,
  };

  const publisher = {
    '@type': 'Organization',
    name: 'edX',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.edx.org/images/logos/edx-logo-elm.svg',
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(
          {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline,
            datePublished,
            dateModified,
            author,
            publisher,
          },
        )}
      </script>
    </Helmet>
  );
}

ArticleStructuredData.propTypes = {
  headline: PropTypes.string.isRequired,
  datePublished: PropTypes.string.isRequired,
  dateModified: PropTypes.string.isRequired,
  byline: PropTypes.string,
};

ArticleStructuredData.defaultProps = {
  byline: 'edX team',
};

export default ArticleStructuredData;
